<template>
  <div v-if="!isAuthenticated">
    <img class="wallpaper" src="@/assets/sign/wallpaper2@x.png" alt="Wallpaper">
    <div class="sign">
      <header class="sign__header">
        <div class="sign__header-inner">
          <div class="sign__logo">
            <img id="logo-vexpo" src="@/assets/header/logo.svg" alt="Logo">
          </div>
          <div class="sign__entry">
            <h3 class="sign__headline text-normal">
              <router-link :to="$i18nRoute({ name: 'register' })">
                {{ $t('auth.login.dont-have-an-account') }}
              </router-link>
            </h3>
            <router-link :to="$i18nRoute({ name: 'register' })">
              <button class="btn btn-grey">{{ $t('auth.login.sign-up') }}</button>
            </router-link>
          </div>
        </div>
      </header>
      <div class="sign__body">
        <div class="sign__text">
          <h2 class="sign__lead">
            {{ $t('auth.login.title') }}
          </h2>
          <h1 class="sign__subtitle" v-html="$t('auth.login.subtitle')">
          </h1>
        </div>


        <div class="sign__form login__form">
          <h2 class="text-gold">{{ $t('auth.login.welcome') }}</h2>
          <div class="sign__error" v-if="error">{{ errorText }}</div>
          <v-form class="sign__inputs" v-model="valid" v-on:submit.prevent="login">
            <input
                class="input-grey"
                v-model="email"
                type="email"
                :placeholder="$t('placeholders.enter-email')"
            />
            <input
                class="input-grey"
                v-model="password"
                type="password"
                :placeholder="$t('placeholders.enter-password')"
            />
            <div class="sign__buttons">
              <button class="btn btn-gold" type="submit">{{ $t('buttons.sign-in') }}</button>
            </div>
            <div class="sign__use_chrome">
              Use Google Chrome for the highest quality
            </div>
          </v-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {authService as auth} from '@/services'
import EventBus from '@/EventBus'
import store from "@/store";
import {userInfo} from "@/controllers/UserInfo";

export default {
  name: 'login',
  mounted() {
    if(this.isAuthenticated) {
      this.$router.push('/')
    }
  },
  data: () => ({
    email: '',
    password: '',
    error: false,
    errorText: '',
    valid: false,
  }),
  computed: {
    ...mapGetters({
      isAuthenticated: 'authentication/isAuthenticated',
    }),
  },
  created() {

  },
  methods: {
    login() {
      this.error = false
      let getCorrectEmail = (v) => /.+@.+/.test(v)
      if(!getCorrectEmail(this.email)) {
        this.error = true
        this.errorText = 'Email should be valid';
        return
      }
      if (!this.email || !this.password) {
        this.error = true
        this.errorText = 'Email and password are required'
        return
      }

      auth
          .login(this.email, this.password)
          .then((data) => {
            console.log(data)
            store.commit('user/set', {
              id: data.user.id,
              firstName: data.user.firstName,
              lastName: data.user.lastName,
              username: data.username,
              phone: data.user.phone,
              email: data.user.email,
              emailVerified: data.emailVerified,
              avatar: data.avatar,
              gender: data.user.gender
            })

            this.$router.push({ name: 'home' })
          })
          .catch((e) => {
            console.log({e})
            if (e.response && e.response.status === 400) {
              //this.errorText = e.response.data
              this.errorText = 'Error, not all data is filled'
              this.error = true
            } else {
              this.errorText = 'Email or password is incorrect'
              this.error = true
            }
          })
    },
  }
}
</script>

<style lang="scss">
  .login {
    &__form {
      margin-top: 80px;
    }
  }

  .sign {
    &__use_chrome {
      margin-top: 20px;
      text-align: center;
    }
  }

</style>


